<mat-dialog-content style="min-width: 400px;">
  <t4-container style="text-align:center">
    <h1>{{ 'Turbo.Bookings.TheftDialog.Title' | translate:'Information'}}</h1>
    <p style="margin-top:10px;"><b>{{ 'Turbo.Bookings.TheftDialog.subHeader' | translate:'Unable to enable trailer'}}</b></p>
    <br />
    <div style="justify-content:space-evenly; display:flex;">
      <img src='/images/icons/Theft.png' style="height:96px;" /> <img src='/images/icons/PoliceIcon.png' style="height:96px; border-radius:100px;" />
    </div>
    <br />
    <p>{{ 'Turbo.Bookings.TheftDialog.txt1' | translate:'This trailer is currently marked as stolen or associated with an ongoing case, possibly involving the police. As a result, it cannot be enabled at this time.'}}</p>
    <p>{{ 'Turbo.Bookings.TheftDialog.txt2' | translate:'If this status is no longer accurate, please contact us to resolve the issue and enable the trailer.'}}</p>
    <div style="margin-top:20px;">
      <ng-container *ngIf="Settings.clientSettings.Language == 'da'">
        <p><mat-icon style="margin-right:10px">call</mat-icon>+45 6342 2211 </p>
      </ng-container>
      <ng-container *ngIf="Settings.clientSettings.Language == 'no'">
        <p><mat-icon style="margin-right:10px">call</mat-icon>+45 919 00 135</p>
      </ng-container>
      <ng-container *ngIf="Settings.clientSettings.Language == 'sv'">
        <p><mat-icon style="margin-right:10px">call</mat-icon>010 707 95 96</p>
      </ng-container>
      <ng-container *ngIf="Settings.clientSettings.Language != 'sv' && Settings.clientSettings.Language != 'no' && Settings.clientSettings.Language != 'da'">
        <p><mat-icon style="margin-right:10px">call</mat-icon>+46 10 707 95 96</p>
      </ng-container>
    </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: right">
    <ng-container *ngIf="Settings.isInAny(['Admin'], true)">
      <button mat-flat-button style="margin: 3px;" (click)="close()" >Close</button>
      <button mat-flat-button color="primary" style="margin: 3px;" (click)="override()">Open anway</button>
    </ng-container>
    <ng-container *ngIf="!Settings.isInAny(['Admin'], true)">
      <button mat-flat-button color="primary" style="margin: 3px;" (click)="close()">OK</button>
    </ng-container>
   
   
  </div>
</mat-dialog-actions>
